var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 4.2333332 4.2333335",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      stopColor: "#000000"
    },
    id: "rect848",
    width: 1.0583334,
    height: 4.2333336,
    x: 2.464252,
    y: -2.1166668,
    rx: 0.26458335,
    ry: 0.26458335,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      strokeWidth: 1.32292,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "fill markers stroke",
      stopColor: "#000000"
    },
    id: "rect1040",
    width: 1.0583334,
    height: 4.2333336,
    x: -0.52916682,
    y: -5.1100855,
    transform: "rotate(135)",
    rx: 0.26458335,
    ry: 0.26458335
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.c2dda184380cfa189a68b1c63cadfbb9.svg";
export { ForwardRef as ReactComponent };